import { nanoid } from "nanoid";
import { nanoid as nanoidNonSecure } from "nanoid/non-secure";
import { isReactNative } from "../../lib/environment";

export default function uniqueId(): string {
  return isReactNative ? nanoidNonSecure() : nanoid();
}
